import apiClient from './apiClient';

export const getOnboardingTemplatesByEntity = async (entityId) => {
  try {
    const url = entityId ? `/onboarding/templates/entity/${entityId}` : '/onboarding/templates/entity/null';
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching templates:', error);
    throw error;
  }
};

export const createOnboardingRequirement = async (data) => {
  try {
    const response = await apiClient.post('/onboarding/requirements', data);
    return response.data;
  } catch (error) {
    console.error('Error creating requirement:', error);
    throw error;
  }
};
